export default __webpack_public_path__ + "static/media/vivek.cc3668ef.png";